//
//
//
//
//

import Material from '@/views/home/_material'
export default {
    components: {
        Material
    }
}
